// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3wuDXCNnqeJzPp3utMHg4r{width:.4rem;height:.40rem;border-radius:50%;margin-right:.12rem}._3B1LMqQ3UQwC_IMCqQtdrt{font-weight:500;font-size:12px;line-height:15px;color:#30313b;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eggLQZZlagkL2ISZSsCB7{display:flex;align-items:center}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": "_3wuDXCNnqeJzPp3utMHg4r",
	"name": "_3B1LMqQ3UQwC_IMCqQtdrt",
	"author": "eggLQZZlagkL2ISZSsCB7"
};
module.exports = ___CSS_LOADER_EXPORT___;
